<template>
  <div :class="['navBar flex-column', programStyle]">
    <div :class="$store.state.userType === 'Field User' ? 'background-top' : 'small-background-top'">
      <div class="top">
        <img
          v-if="programImage"
          :class="['logo', programImage]"
          :src="getProgramImage(programImage)"
          @click="navigate('Programs')"
        />
      </div>
      <div class="middle">
        <div
          v-for="item in currentNavBar"
          :key="item.key"
          :class="{ container: true, active: activeNavTab ? item.key === activeNavTab.key : false }"
          @click="navigate(item)"
        >
          <div class="item sub-no-color" v-if="item.show">
            <div class="img-container">
              <img class="icon" :src="item.icon" />
            </div>
            <span>{{ $t(item.text) }}</span>
            <div v-if="item.amount > 0" class="appeal-circle">{{ item.amount }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom" v-if="!$route.params.entity">
      <div @click="goToHelp" v-if="currentProgram" to="/help" :class="{ item: true, active: $route.name === 'Help' }">
        {{ $t('help') }}
      </div>
      <div class="item">
        <Languages></Languages>
      </div>
      <div
        class="item"
        :class="{ item: true, active: $route.name === 'Field-Security-Center' }"
        @click="goToFieldSecurityCenter"
        v-if="fieldSecurityCenter"
      >
        {{ $t('security-center') }}
      </div>
      <div
        class="item"
        :class="{ item: true, active: $route.name === 'UserLookup' }"
        @click="goToLookup"
        v-if="navLookup"
      >
        {{ $t('user-lookup') }}
      </div>
      <div class="item" @click="logOut">{{ $t('log-out') }}</div>
    </div>
    <div class="bottom" v-else>
      <div
        ref="dealerSecurityCenter"
        :class="['item', routeName === 'Dealer-Security-Center' ? 'bolden' : '']"
        v-if="dealerSecurityCenter"
        @click="showDealerSecurityCenter"
      >
        {{ $t('security-center') }}
      </div>
      <div
        ref="profile"
        :class="['item', routeName === 'Profile' ? 'bolden' : '']"
        v-if="dealerSecurityCenter"
        @click="showProfile"
      >
        {{ $t('profile') }}
      </div>
      <div
        ref="programRules"
        :class="['item', routeName === 'Program-Rules' ? 'bolden' : '']"
        v-if="
          currentProgram === 'US CF' ||
          currentProgram === 'US Wgnr' ||
          currentProgram === 'US ALFA' ||
          currentProgram === 'US CED'
        "
        @click="showProgramRules"
      >
        {{ $t('program-info') }}
      </div>
      <div
        ref="help"
        v-if="currentProgram"
        :class="['item', routeName === 'Dealer-Help' ? 'bolden' : '']"
        @click="showHelp"
      >
        {{ $t('help') }}
      </div>
      <div class="item">
        <Languages></Languages>
      </div>

      <div class="item" @click="logOut">{{ $t('log-out') }}</div>
    </div>
  </div>
</template>

<script>
import NavBarField from '@/utils/navBar/navBarField';
import NavBarDealer from '@/utils/navBar/navBarDealer';
import NavBarDashboard from '@/utils/navBar/navBarDashboard';
import NavBarPrograms from '@/utils/navBar/navBarPrograms';
import navBarCC from '@/utils/navBar/navBarCC';
import NavBarCCDashboard from '@/utils/navBar/navBarCCDashboard';
import Languages from '@/components/Language.vue';
import { mapState } from 'vuex';

export default {
  name: 'NavBar',
  components: { Languages },
  data() {
    return {
      rowCount: 10,
      homePageNumber: 1,
      entityParam: '05002',
      navItems: {},
    };
  },
  methods: {
    navigate(item) {
      if (this.surveyInterference && this.surveyPermission !== 'Y' && item.key === 'Forms') {
        return;
      }
      if (this.$route.name === 'Programs') {
        if (this.currentProgram === null) {
          return;
        }
      }
      if (item === 'Programs') {
        if (this.userType === 'Field User') {
          this.removeProgram();
          this.$router.push({
            name: 'Programs',
          });
          this.$store.state.activeNavTab = this.currentNavBar[0];
        }
        return;
      }
      if (item.routeName) {
        if (item.routeName === 'Programs') {
          this.removeProgram();
        }
        const { currentProgram, entity } = this;
        if (this.$route.name === 'Help' && entity && currentProgram) {
          this.$router.push(`/dealer/${currentProgram}/${entity}`);
        }
        // Restrict access to Survey Interference based on user type and permissions
        if (this.userType === 'Dealer' && item.routeName === 'DealerSI') {
          if (
            this.navPermissions.some(
              (permission) => permission.navGroup === 'SI Subsystem' && permission.permission === 0,
            )
          ) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: 'You do not have permission to access this page.',
            });
            return;
          }
        }
        // Restrict access to Archive based on user type and permissions
        if (this.userType === 'Dealer' && item.routeName === 'Archive') {
          if (
            this.navPermissions.some((permission) => permission.navGroup === 'Archives' && permission.permission === 0)
          ) {
            this.$notify({
              group: 'primary',
              type: 'error',
              text: 'You do not have permission to access this page.',
            });
            return;
          }
        }
        this.$router.push({
          name: item.routeName,
        });
      } else {
        this.setActiveDealerTab(item);
      }
    },
    removeProgram() {
      this.$store.state.global.programs = null;
      this.$store.state.global.programName = null;
      this.$store.state.global.programImage = null;
      this.$store.state.surveyInterference = null;
      this.$store.state.global.programStyle = null;
    },
    logOut() {
      this.$store
        .dispatch('logout')
        .then(() => {
          this.$notify({
            group: 'primary',
            type: 'success',
            text: this.$t('user-logged-out-successfully'),
          });
        })
        .catch((error) => {
          this.$notify({
            group: 'primary',
            type: 'error',
            text: error,
          });
        });
    },
    setActiveDealerTab(dealerTab) {
      this.$router.push({
        name: dealerTab.key,
      });
    },
    showDealerSecurityCenter() {
      this.$router.push({
        name: 'Dealer-Security-Center',
      });
    },
    showProfile() {
      this.$router.push({
        name: 'Profile',
      });
    },
    showHelp() {
      this.$router.push({
        name: 'Dealer-Help',
      });
    },
    showProgramRules() {
      this.$router.push({
        name: 'Program-Rules',
      });
    },
    getProgramImage(image) {
      if (image) {
        if (image === 'WagLogo') {
          return require('@/assets/new/WagLogoWhite.png');
        }
        if (image === 'CFLogo') {
          return require('@/assets/new/CFLogoWhite.svg?external');
        }
        if (image === 'PRLogo') {
          return require('@/assets/new/PRLogoWhite.png');
        }
        if (image === 'DPBLogo') {
          return require('@/assets/new/DPBLogoWhite.png');
        }
        // eslint-disable-next-line import/no-dynamic-require
        return require(`@/assets/new/${image} - Lite.png?external`);
      }
      return null;
    },
    goToHelp() {
      this.$store.state.activeNavigation = this.currentNavBar;
      this.$router.push({
        name: 'Help',
      });
    },
    goToLookup() {
      this.$store.state.activeNavigation = this.currentNavBar;
      this.$router.push({
        name: 'UserLookup',
      });
    },
    goToFieldSecurityCenter() {
      this.$store.state.activeNavigation = this.currentNavBar;
      this.$router.push({
        name: 'Field-Security-Center',
      });
    },
  },
  computed: {
    ...mapState('global', ['navPermissions', 'programImage', 'programStyle']),
    ...mapState(['userType', 'appealInfo', 'surveyInterference', 'surveyPermission', 'appealable']),
    ...mapState({
      currentProgram: (state) => state.global.programName,
    }),
    currentNavBar() {
      if (this.$route.name === 'Programs') {
        return NavBarPrograms();
      }
      if (
        this.$route.name === 'Dealer-List' ||
        this.$route.name === 'Field-Forms' ||
        this.$route.name === 'FieldSI' ||
        this.$route.name === 'Summary' ||
        this.$route.name === 'Survey-Interference-Letter-Field' ||
        this.$route.name === 'Appeal-Details-Field'
      ) {
        if (this.navPermissions) {
          if (this.navPermissions.some((permission) => permission.navGroup === 'Program Control Center')) {
            return NavBarCCDashboard();
          }
        }
        return NavBarDashboard();
      }
      if (
        this.$route.name === 'CCDashboard' ||
        this.$route.name === 'CCMessages' ||
        this.$route.name === 'CCForms' ||
        this.$route.name === 'CCAssets' ||
        this.$route.name === 'CCCommunicationcenter' ||
        this.$route.name === 'CCProfile'
      ) {
        return navBarCC();
      }
      if (
        this.$route.name === 'Help' ||
        this.$route.name === 'UserLookup' ||
        this.$route.name === 'Field-Security-Center'
      ) {
        return this.$store.state.activeNavigation;
      }
      if (this.userType === 'Dealer') {
        if (this.$store.state.appealable) {
          return NavBarDealer(1);
        }

        return NavBarDealer();
      }
      return NavBarField();
    },
    navLookup() {
      if (this.navPermissions && this.currentProgram) {
        return this.navPermissions.some((permission) => permission.navGroup === 'Lookup');
      }
      return false;
    },
    fieldSecurityCenter() {
      if (this.navPermissions && this.currentProgram) {
        return this.navPermissions.some((permission) => permission.navGroup === 'Field Security Center');
      }
      return false;
    },
    dealerSecurityCenter() {
      if (this.navPermissions && this.currentProgram) {
        return this.navPermissions.some((permission) => permission.navGroup === 'Dealer Security Center');
      }
      return false;
    },
    entity() {
      if (this.$store.state.loginInfo) {
        return this.$store.state.login.loginInfo.entity;
      }
      return null;
    },
    activeNavTab() {
      let activeNav = null;
      this.currentNavBar.forEach((item) => {
        if (item.routeName === this.routeName) {
          this.$store.state.activeNavTab = item;
          activeNav = item;
        }
      });
      return activeNav;
    },
    activePeriod() {
      if (this.$store.state.activePeriod) {
        return this.$store.state.activePeriod.period;
      }
      return null;
    },
    routeName() {
      return this.$route.name;
    },
  },
  watch: {
    currentProgram(newProgram) {
      if (this.$route.name !== 'Dealer' && newProgram !== null) {
        this.currentNavBar.forEach((item) => {
          this.$set(item, 'show', true);
        });
        this.$store.state.activeNavTab = this.currentNavBar[1];
      } else if (newProgram === null) {
        this.currentNavBar.forEach((item) => {
          if (item.key !== 'Programs') {
            this.$set(item, 'show', false);
          }
        });
      }
    },
    currentNavBar(newNav, oldNav) {
      this.$store.state.activeNavBar = newNav;
      if (newNav[0].key !== oldNav[0].key) {
        this.$store.state.activeNavTab = this.currentNavBar[0];
        this.$store.state.activeNavBar = newNav;
      }
      if (this.currentProgram === null) {
        this.currentNavBar.forEach((item) => {
          if (item.key !== 'Programs') {
            this.$set(item, 'show', false);
          }
        });
      }
    },
  },
  created() {
    if (this.$route.name !== 'Dealer') {
      const index = this.currentNavBar.findIndex((item) => item.key === 'Programs');
      this.$store.state.activeNavTab = this.currentNavBar[index];
    } else {
      const index = this.currentNavBar.findIndex((item) => item.key === 'Dashboard');
      this.$store.state.activeNavTab = this.currentNavBar[index];
    }
    if (this.$route.params.domain) {
      this.$store.state.activeNavTab = this.currentNavBar.find((item) => item.key === 'Dashboard');
    }
  },
};
</script>

<style lang="scss" scoped>
.navBar {
  width: 300px;
  background-color: #f8f8f9;
  box-shadow: 2px 2px 10px #c6c6c8;
  font-size: 18px;
  z-index: 3;
  .background-top,
  .small-background-top {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .background-top {
    background-image: url('../assets/img/Stellantis-blue-bg.png');
  }
  .small-background-top {
    background-image: url('../assets/img/Stellantis-blue-bg_smaller.png');
  }
  .top {
    min-height: 120px;
    padding-top: 30px;
    background-color: transparent;
    .logo {
      width: 200px;
      cursor: pointer;
    }
  }
  .middle {
    color: white;
    background-color: transparent;
    padding-bottom: 30px;
    box-shadow: 0px 3px 6px #00000029;
    .container {
      display: flex;
      cursor: pointer;
      .item {
        padding: 15px 30px 15px 30px;
        text-align: left;
        display: flex;
        align-items: center;
        .img-container {
          width: 18px;
          margin-right: 12px;
          .icon {
            margin: 0 auto;
            display: flex;
          }
        }
      }
      &.active {
        background-color: #43aaa0;
      }
    }
  }
  .bottom {
    color: $primary;
    margin-top: 30px;
    font-size: 14px;
    .item {
      color: $primary;
      margin-bottom: 30px;
      text-align: left;
      padding-left: 30px;
      cursor: pointer;
      display: block;
      text-decoration: none;
      padding-right: 10px;
    }
    .bolden {
      font-weight: bold;
    }
    .active {
      font-weight: 600;
    }
  }
}
.appeal-circle {
  background: #fff;
  color: $primary;
  height: 25px;
  width: 25px;
  border-radius: 50px;
  margin-left: 10px;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 14px;
}
</style>
